module.exports = __webpack_public_path__ + "img/logo-small.ce1341c4.png";